import config from '../../config';

export default {
  url: `${config.api.baseURL}/search?q=:term`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/search/get.js